import memoizeOne from 'memoize-one'

import Campaign from '../models/Campaign'

export default memoizeOne((campaigns: Campaign[]) => {
  return campaigns.sort((a: Campaign, b: Campaign) =>
    a.name.localeCompare(b.name)
  )
})
